import { ReactNode } from 'react';

export const ActionTypes = {
  SELECT_SUB_ORGANIZATION: 'SELECT_SUB_ORGANIZATION',
  SELECT_PARENT_ORGANIZATION: 'SELECT_PARENT_ORGANIZATION',
  SET_ORGANIZATIONS: 'SET_ORGANIZATIONS',
  SET_SUB_ORGANIZATIONS: 'SET_SUB_ORGANIZATIONS',
  BUMP_ORG_VERSION: 'BUMP_ORG_VERSION'
} as const;

export interface IOrganizationsProps {
  children: ReactNode;
}

type StateResult = {
  label: string;
  value: string;
  icon?: string;
};

export type State = {
  selected: string;
  parentSelected: string;
  subSelected: string;
  results: StateResult[];
  subResults: StateResult[];
  /**
   * Monotonic counter bumped on every org-switch
   * (parent/sub change). Page-level fetch useEffects add this to
   * their dependency array to re-run after the user picks a new org.
   * Replaces the Apollo `client.refetchQueries(...)` invalidation the
   * legacy provider used.
   */
  orgVersion: number;
};

type SelectOrganization = {
  type:
    | typeof ActionTypes.SELECT_SUB_ORGANIZATION
    | typeof ActionTypes.SELECT_PARENT_ORGANIZATION;
  data: string;
};

type SetOrganizations = {
  type:
    | typeof ActionTypes.SET_ORGANIZATIONS
    | typeof ActionTypes.SET_SUB_ORGANIZATIONS;
  data: StateResult[];
};

type BumpOrgVersion = {
  type: typeof ActionTypes.BUMP_ORG_VERSION;
};

export type Action = SelectOrganization | SetOrganizations | BumpOrgVersion;

export type DispatchContext = {
  onChangeSub: (value: string) => void;
  onChangeParent: (value: string) => void;
};

export type Dispatch = (action: Action) => void;
